import { RootState } from 'redux/store';
import { Tab } from 'pages/DodaFront/View/JobSearchDetail/types/tab';

/**
 * tabSelector
 * @param state
 * @returns タブのクエリパラメータ
 */
export const tabSelector = (state: RootState) =>
  state.queryParams.queryParams?.tab as Tab;
